import React from "react";
import classNames from "classnames";
import isEqual from "lodash/isEqual";
import InfoTooltip from "components/InfoTooltip";
import LoadingDots from "components/LoadingDots";
import WarningTooltip from "components/WarningTooltip";
import CheckboxWithLargeImage from "components/Input/CheckboxWithLargeImage";
import classes from "./style.module.scss";
import sharedClasses from "../style.module.scss";

const ImageSelect = ({
    name,
    label,
    input,
    className,
    options = [],
    emptyMessage = "No options meet the requirements.",
    hideLabel = false,
    disabled = false,
    isLoading = false,
    info = "",
    warning = "",
    customStyles = {},
    selectOne = false,
    dimensions = {},
    fullScreen = false,
    displayNotes = false,
}) => {
    const classNamesList = [
        classes.selectField,
        sharedClasses.inputField,
        className && className,
        disabled && classes.disabled,
        hideLabel && classes.labelHidden,
        warning && classes.warning,
    ].filter((c) => c);

    const { value = [], onChange } = input;
    const selected = value;

    return (
        <div
            className={classNamesList.join(" ")}
            style={customStyles}
        >
            <div className={classes.fieldHeader}>
                {label && (
                    <label className={hideLabel ? "invisible" : ""} htmlFor={name}>
                        {label} {selectOne ? "" : `(${value.length} Selected)`}
                    </label>
                )}
                {isLoading && (
                    <div className={classes.loading}>
                        <LoadingDots />
                    </div>
                )}
                {info && <InfoTooltip className={sharedClasses.infoTooltip} style={{ position: "relative", marginBottom: "0.25rem" }} info={info} />}
                {warning && (
                    <WarningTooltip className={`${classes.warningTooltip} ${info && classes.pushLeft}`} warning={warning} />
                )}
            </div>
            {!isLoading && (
                <div className={classNames(classes.optionsContainer, { [classes.fullScreen]: fullScreen })}>
                    {options.length > 0 ? (
                        <div className={classes.options}>
                            {options.map(({ value, label, disabled = false, image, notes = "" }, index) => {
                                const classNamesList = [classes.checkboxOption, isEqual(selected, value) && classes.selected].filter(
                                    (c) => c
                                );

                                return (
                                    <CheckboxWithLargeImage
                                        key={index}
                                        className={classNamesList}
                                        input={{
                                            value: selected.includes(value), // checked
                                            onChange: (event) => {
                                                if (disabled) {
                                                    return;
                                                }

                                                if (selectOne) {
                                                    if (!selected.includes(value)) {
                                                        onChange([value]);
                                                    } else {
                                                        onChange([]);
                                                    }
                                                    return;
                                                }

                                                let newValue = selected;

                                                if (!selected.includes(value)) {
                                                    newValue = [...selected, value];
                                                } else {
                                                    newValue = [...selected].filter((item) => item !== value);
                                                }

                                                onChange(newValue);
                                            },
                                        }}
                                        label={label}
                                        name={`${value}`}
                                        disabled={disabled}
                                        image={image}
                                        dimensions={dimensions}
                                        notesInput={{ displayNotes, notes }}
                                    />
                                );
                            })}
                        </div>
                    ) : (
                        <div className={classes.emptyFilter}>
                            <span>{emptyMessage}</span>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default ImageSelect;
